export default __webpack_public_path__ + "static/media/AM_00777 copy.700eb22f.jpg";